import ChartCard from "../../../components/ui/ChartCard";
import { buildStackedBarOptions } from "../chartOptions";
import { buildLikertPeriodChart } from "./resultHelpers";
import StructuredPeriodAxis from "./StructuredPeriodAxis";

const LIKERT_COLORS = [
  "#16a34a",
  "#84cc16",
  "#eab308",
  "#facc15",
  "#f97316",
  "#ef4444",
];

function formatPercentage(value) {
  const number = Number(value) || 0;
  return Number.isInteger(number) ? `${number}%` : `${number.toFixed(1)}%`;
}

export default function LoonOpZandLikertPanel({ questions, filters, title, info }) {
  const chart = buildLikertPeriodChart(questions, filters);
  const issues = filters?.selected_issues || [];
  const options = buildStackedBarOptions({
    categories: chart.categories,
    colors: LIKERT_COLORS.slice(0, chart.series.length),
    horizontal: true,
    stackType: "100%",
    dataLabels: true,
    legendPosition: "bottom",
    tooltipFormatter: (_value, context) => {
      const detail = chart.details?.[context.seriesIndex]?.[context.dataPointIndex];
      return detail
        ? `${formatPercentage(detail.percentage)} (${detail.count} respondenten)`
        : "";
    },
  });

  options.chart.animations = { enabled: false };
  options.plotOptions.bar.barHeight = "72%";
  options.xaxis = {
    ...options.xaxis,
    min: 0,
    max: 100,
    tickAmount: 5,
    labels: { formatter: (value) => `${Math.round(Number(value))}%` },
  };
  options.yaxis = {
    labels: {
      show: false,
    },
  };
  options.dataLabels = {
    enabled: true,
    formatter: (_value, context) => {
      const detail = chart.details?.[context.seriesIndex]?.[context.dataPointIndex];
      if (!detail || detail.percentage < 5) {
        return "";
      }
      const percentage = formatPercentage(detail.percentage);
      return detail.percentage >= 12
        ? `${percentage}  ${detail.count}`
        : percentage;
    },
    style: {
      fontSize: "10px",
      fontWeight: 600,
      colors: ["#111827"],
    },
    dropShadow: { enabled: false },
  };
  options.legend = {
    ...options.legend,
    fontSize: "13px",
    markers: { radius: 2 },
  };
  options.tooltip = {
    shared: false,
    intersect: false,
    y: options.tooltip?.y,
  };
  options.grid = { padding: { left: 0, right: 20, bottom: 20 } };

  const rowCount = chart.categories.length;
  const height = Math.max(620, rowCount * 30 + 130);

  return (
    <ChartCard
      chartKey={`loonopzand-likert-${filters?.selected_issues?.join("-")}`}
      title={title || "4. In hoeverre bent u het eens met de volgende stellingen?"}
      info={info || "Iedere balk toont de verdeling onder respondenten die de betreffende stelling in die periode beantwoordden."}
      type="bar"
      options={options}
      series={chart.series}
      height={height}
      chartSideContent={(
        <StructuredPeriodAxis
          groups={questions.map((question) => ({
            key: question.question_id,
            label: question.text,
          }))}
          issues={issues}
        />
      )}
    />
  );
}
